import { CatalogItemType } from '@common/model/catalog/item/type';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { Button, ButtonProps } from '@cp/ds/src/components/button';
import { useClientWebRouteProps, usePathGenerator } from '@cp/entities/clientWebRoutes';
import { useRouter } from '@cp/shared/router';
import React from 'react';
import { useAuthInterceptor } from 'src/features/auth';

export interface CatalogRoutedButtonProps extends ButtonProps {}

export const CatalogRoutedButton: React.FC<React.PropsWithChildren<CatalogRoutedButtonProps>> = ({ children, ...buttonProps }) => {
  const { careerId } = useClientWebRouteProps<ClientWebPage.Catalog>();
  const router = useRouter();
  const pathGenerator = usePathGenerator();
  const interceptAuth = useAuthInterceptor();

  const handleClick = interceptAuth(() =>
    router.navigate(pathGenerator({ page: ClientWebPage.Catalog, pageProps: { careerId, catalogType: CatalogItemType.Resume } })),
  );

  return (
    <Button as="span" onClick={handleClick} {...buttonProps}>
      {children}
    </Button>
  );
};
